import { render, staticRenderFns } from "./MedidasProteccion.vue?vue&type=template&id=4f212df4&scoped=true&"
import script from "./MedidasProteccion.vue?vue&type=script&lang=js&"
export * from "./MedidasProteccion.vue?vue&type=script&lang=js&"
import style0 from "./MedidasProteccion.vue?vue&type=style&index=0&id=4f212df4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f212df4",
  null
  
)

export default component.exports